import React, { useRef, useEffect, useState, useContext } from 'react';
import { cloneDeep } from 'lodash-es';
import { PaperAirplane } from '../../../../SVG';
import { useRingStyle } from '../../../../tailwind_common/util';
import '../../../utils/Flows';
import { PartnerCustomizationContext } from '../../../../tailwind_clearstep/Partners/symptom_check/PartnerCustomizations';
import { useIsEnabled } from '../../../../clearstep/util/Split';
import { fetchWorkflowById } from '../../../utils/WidgetUtil';
import { addQueryParamToPath } from '../../../../clearstep/util/AppHelpers';
import { WidgetStateChangeType } from '../../Widget';
import { THEME } from '../../../../clearstep/util/Theme';
var SearchWorkflows = function (props) {
    var _a = useState(''), text = _a[0], setText = _a[1];
    var textareaRef = useRef(null);
    var MAX_CHAR_LIMIT = 250;
    var isDisabled = text.length < 1 || text.length > MAX_CHAR_LIMIT;
    var partnerCustomizations = useContext(PartnerCustomizationContext);
    var isNlpEnabled = function () { return useIsEnabled('widget_patient_service_nlp') === 'on'; };
    var ringStyle = useRingStyle();
    useEffect(function () {
        var textarea = textareaRef.current;
        if (textarea) {
            textarea.addEventListener('input', handleInput);
            return function () { return textarea.removeEventListener('input', handleInput); };
        }
    }, []);
    var handleInput = function (event) {
        var textarea = event.target;
        // Update textbox height
        textarea.style.height = 'auto'; // Only reset if wrapping occurs
        textarea.style.height = "".concat(textarea.scrollHeight, "px");
        textarea.style.borderRadius = textarea.scrollHeight > 56 ? '20px' : '60px';
        if (event.target.value.length <= MAX_CHAR_LIMIT) {
            setText(event.target.value);
        }
    };
    var onSubmit = function () {
        if (text.length <= 0 || text.length > MAX_CHAR_LIMIT) {
            return;
        }
        var workflows = props.workflows, setWorkflow = props.setWorkflow;
        var config = partnerCustomizations.widgetSearchConfig();
        var searchWorkflow = cloneDeep(fetchWorkflowById(config.workflow, workflows));
        if (!searchWorkflow) {
            console.error("search workflow not added for partner: ".concat(THEME.partner));
            return;
        }
        searchWorkflow.path = addQueryParamToPath(searchWorkflow.path, config.queryParamKey, text);
        setWorkflow(searchWorkflow, WidgetStateChangeType.MANUAL);
    };
    return (React.createElement(React.Fragment, null, isNlpEnabled() && (React.createElement("div", { className: "box-border w-full border border-x-0 border-b-0 border-solid border-gray-300 bg-white px-4 py-3 shadow-white-fade" },
        React.createElement("div", { className: "relative box-border w-full" },
            React.createElement("textarea", { ref: textareaRef, className: "h-14 max-h-148 w-full resize-none overflow-hidden rounded-3.75rem border border-gray-300 p-4 pr-16 font-primary text-base text-gray-900 shadow-sm placeholder:text-gray-500 focus:border-opacity-0 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-0", rows: 1, placeholder: "How can I help?", value: text, onChange: handleInput, onKeyDown: function (e) {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        onSubmit();
                    }
                }, maxLength: MAX_CHAR_LIMIT }),
            React.createElement("button", { className: "absolute right-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-primary text-white focus:outline-none focus:ring focus:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-gray-200", disabled: isDisabled, style: ringStyle, onClick: function () { return onSubmit(); } },
                React.createElement(PaperAirplane, { fill: isDisabled ? 'fill-gray-400' : 'fill-white' })))))));
};
export default SearchWorkflows;
